import { EventLogin } from './EventLogin';

export default EventLogin;
